import React from "react";
import { Grid } from "@mui/material";

export default function NationalityFieldContainer({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <>
      <Grid className="scd-container-base" size={{ xs: 12 }}>
        {children}
      </Grid>
    </>
  );
}
